import * as _ from 'lodash';
import * as moment from 'moment';
import { ICluster } from '@nkr/models/cluster';
import { Utility } from '@nkr/services/utility';
import { SwapGridWrapper } from '../styles';
import SingleEpletMmRisk from '@nkr/views/swap-management/single-eplet-mm-risk';
import AlleleMatch from '@nkr/components/allele-match';

interface IProps {
    includePreselectStatus: boolean,
    sidebar?: boolean,
    swaps: ICluster[],
}

const Swaps = (props: IProps) => {
    let showOldEvalMessage = false;

    return (
        <>
            <SwapGridWrapper condensed bordered style={{ fontSize: props.sidebar ? 12 : null }}>
                <thead>
                    <tr>
                        <th rowSpan={2}>Position</th>
                        <th colSpan={4}>Donor</th>
                        <th colSpan={6}>Recipient</th>

                        <th rowSpan={2}>Pair<br />Match<br />Power</th>

                        {props.includePreselectStatus && (
                            <th rowSpan={2}>Preselect<br />Status</th>
                        )}

                        <th rowSpan={2}>Eplet<br />MM</th>
                        <th rowSpan={2}>Allele<br />Match</th>

                        <th colSpan={2}>Target Surgery Dates</th>
                    </tr>
                    <tr>
                        <th>Center</th>
                        <th>Alias</th>
                        <th>ABO</th>
                        <th>Age</th>

                        <th>Center</th>
                        <th>Alias</th>
                        <th>ABO</th>
                        <th>Age</th>
                        <th>cPRA4</th>
                        <th>Wait Time</th>

                        <th>Donor</th>
                        <th>Recipient</th>
                    </tr>
                </thead>
                <tbody>
                    {props.swaps.map(swap => {
                        const sortedPositions = _.sortBy(swap.positions, x => x.positionNumber);

                        return sortedPositions.map(position => {
                            var donor = position.donor;
                            var recipient = position.recipient;
                            var donorPreselectDecision = position.donorPreselect != null ? position.donorPreselect.donorPreselectDecision : 'Pending';
                            var recipientCenter = recipient != null ? recipient.center.alias : '';
                            var recipientAlias = recipient != null ? recipient.alias : '';
                            var recipientBloodType = recipient != null ? recipient.bloodType : '';
                            var recipientAge = recipient != null ? recipient.age : '';
                            var recipientCpra = recipient != null ? recipient.cpra4 : 0;
                            var recipientMonthsWaiting = position.wt;
                            var kidneyPickupDate = recipient != null && donor.logistics != null ? donor.logistics.kidneyPickupDateTime : '';
                            var kidneyArrivalDate = recipient != null && donor.logistics != null ? donor.logistics.kidneyArrivalDateTime : '';

                            let yearsSince = moment().diff(moment(donor.dateOfEvaluation), 'years');

                            if (yearsSince >= 1) {
                                showOldEvalMessage = true;
                            }

                            return (
                                <tr>
                                    <td style={{ textAlign: 'center' }}>{position.positionNumber}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        {position.donor.center.alias}
                                        {position.donor.rdnCenterAlias != '' ? <>&nbsp;(<span style={{ fontSize: 12, color: 'red' }}>{position.donor.rdnCenterAlias}</span>)</> : null}
                                    </td>
                                    <td style={{ textAlign: 'center', backgroundColor: yearsSince >= 1 ? 'yellow' : null }}>
                                        {position.donor.alias}{yearsSince >= 1 ? ' *' : null}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>{Utility.realBloodType(position.donor.bloodType, position.donor.aboASubType, position.donor.aboAbSubType)}</td>
                                    <td style={{ textAlign: 'center' }}>{position.donor.age}</td>
                                    <td style={{ textAlign: 'center' }}>{recipientCenter}</td>
                                    <td style={{ textAlign: 'center' }}>{recipientAlias}</td>
                                    <td style={{ textAlign: 'center' }}>{recipientBloodType}</td>
                                    <td style={{ textAlign: 'center' }}>{recipientAge}</td>
                                    <td style={{ textAlign: 'center' }}>{recipientCpra != null ? recipientCpra : 0}</td>
                                    <td style={{ textAlign: 'center' }}>{recipientMonthsWaiting}</td>
                                    <td style={{ textAlign: 'center' }}>{position.pmp}</td>

                                    {props.includePreselectStatus && (
                                        <td style={{ textAlign: 'center' }}>{donorPreselectDecision}</td>
                                    )}

                                    <td style={{ textAlign: 'center' }}><SingleEpletMmRisk data={position.singleEpletMmRisk} isAdmin={true} placement={props.sidebar ? "left" : undefined} /></td>
                                    <td style={{ textAlign: 'center' }}><AlleleMatch bmtMm={position.bmtMm} displayAsInline={false} /></td>

                                    <td style={{ textAlign: 'center' }}>{kidneyPickupDate}</td>
                                    <td style={{ textAlign: 'center' }}>{kidneyArrivalDate}</td>
                                </tr>
                            );
                        })
                    })}
                </tbody>
                {showOldEvalMessage && (
                    <tbody>
                        <tr>
                            <td colSpan={18} style={{ backgroundColor: 'yellow', padding: '2px 5px', textAlign: 'left' }}>
                                * Donor's evaluation has not been updated in over 1 year
                            </td>
                        </tr>
                    </tbody>
                )}
            </SwapGridWrapper>


        </>
    )
}

export default Swaps;